import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarDays, MapPin } from "lucide-react";
import { api } from "../lib/api";

export default function SchedulePage() {
  const [matches, setMatches] = useState([]);
  useEffect(() => { api.get("/matches").then((r) => setMatches(r.data)); }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-12">
      <div className="section-label">Fixtures</div>
      <h1 className="font-display font-black uppercase text-4xl sm:text-5xl tracking-tight mt-1 mb-8 flex items-center gap-3">
        <CalendarDays className="w-8 h-8 text-amber-400" /> Full Schedule
      </h1>

      <div className="tile p-2 divide-y divide-white/5">
        {matches.map((m) => (
          <Link key={m.id} to={`/matches/${m.id}`} className="flex items-center justify-between p-4 hover:bg-white/5 rounded-lg transition-colors" data-testid={`schedule-row-${m.id}`}>
            <div className="flex items-center gap-4">
              <div className="w-14 h-14 rounded-lg bg-[#0B0F17] border border-white/10 flex flex-col items-center justify-center">
                <span className="font-display font-black text-lg text-amber-400 leading-none">{m.format}</span>
              </div>
              <div>
                <div className="font-display font-bold text-lg uppercase">{m.short}</div>
                <div className="text-xs text-slate-400 mt-0.5 flex items-center gap-1.5"><MapPin className="w-3 h-3" />{m.venue} • {m.series}</div>
              </div>
            </div>
            <div className="text-right">
              {m.status === "LIVE" ? (
                <div className="pill bg-emerald-500/15 text-emerald-300 border border-emerald-500/40"><span className="live-dot" />Live</div>
              ) : m.status === "UPCOMING" ? (
                <div className="text-xs">
                  <div className="pill bg-sky-500/15 text-sky-300 border border-sky-500/30">Upcoming</div>
                  <div className="font-mono-data text-slate-400 mt-1">{m.starts_at || "TBA"}</div>
                </div>
              ) : (
                <div className="pill bg-slate-800 text-slate-400 border border-slate-700">Completed</div>
              )}
            </div>
          </Link>
        ))}
      </div>

      <div className="mt-10">
        <div className="section-label mb-3">Featured spot</div>
        <div className="rounded-2xl overflow-hidden border border-amber-500/30 shadow-2xl shadow-amber-500/10 max-w-3xl">
          <video
            src="https://customer-assets-wrfwihn1.emergentagent.net/job_live-wicket-forecast/artifacts/umzw614r_ELVA%20AD%20%232.mp4"
            autoPlay
            loop
            muted
            playsInline
            controls
            className="w-full h-auto block"
            data-testid="schedule-footer-video"
          />
        </div>
      </div>
    </div>
  );
}
